"use client";

import { Conversation, ConversationContent } from "@/components/ai-elements/conversation";
import { EasyExerciseUI } from "@/components/ai-elements/easy-exercise-ui";
import { Message, MessageContent } from "@/components/ai-elements/message";
import { Response } from "@/components/ai-elements/response";
import { ExersiseTypes } from "@l_learn/shared";

type SampleMessage = {
	id: string;
	role: "user" | "assistant";
	content?: string;
	exercise?: ExersiseTypes.EasyExercise;
};

const sampleExercise: ExersiseTypes.EasyExercise = {
	type: ExersiseTypes.TestVariantId.Easy,
	text: [
		{
			type: ExersiseTypes.Content.String,
			text: "Yesterday, I"
		},
		{
			type: ExersiseTypes.Content.FillGap
		},
		{
			type: ExersiseTypes.Content.String,
			text: " to the store and"
		},
		{
			type: ExersiseTypes.Content.FillGap
		},
		{
			type: ExersiseTypes.Content.String,
			text: " some groceries. Then I"
		},
		{
			type: ExersiseTypes.Content.FillGap
		},
		{
			type: ExersiseTypes.Content.String,
			text: " home."
		}
	],
	variants: [
		{ text: "went" },
		{ text: "bought" },
		{ text: "returned" },
		{ text: "go" },
		{ text: "buy" },
		{ text: "return" }
	],
	partId: "sample-1",
	description: "Fill in the blanks with the correct past tense verbs."
};

const sampleMessages: SampleMessage[] = [
	{
		id: "1",
		role: "user",
		content: "Can you help me practice past tense verbs?"
	},
	{
		id: "2",
		role: "assistant",
		content:
			"Of course! Let me create a quick exercise for you. Fill in the blank with the correct form of the verb:"
	},
	{
		id: "3",
		role: "assistant",
		exercise: sampleExercise
	}
];

export const SampleEasyExercise = () => {
	return (
		<div className="p-2 bg-background/30 rounded-3xl">
			<Conversation>
				<ConversationContent>
					{sampleMessages.map((message) => {
						if (message.role === "assistant" && message.exercise) {
							return (
								<Message from="assistant" key={message.id}>
									<MessageContent>
										<div className="bg-card rounded-2xl p-4 flex flex-col gap-4">
											{message.exercise.description && (
												<p className="text-muted-foreground">
													{message.exercise.description}
												</p>
											)}
											<EasyExerciseUI
												exercise={message.exercise}
												isSubmitted={false}
											>
												<EasyExerciseUI.Content />
												<EasyExerciseUI.Variants />
											</EasyExerciseUI>
										</div>
									</MessageContent>
								</Message>
							);
						}

						if (message.role === "assistant") {
							return (
								<Message from="assistant" key={message.id}>
									<MessageContent>
										<Response>{message.content}</Response>
									</MessageContent>
								</Message>
							);
						}

						return (
							<Message from="user" key={message.id}>
								<MessageContent>
									<Response>{message.content}</Response>
								</MessageContent>
							</Message>
						);
					})}
				</ConversationContent>
			</Conversation>
		</div>
	);
};
